"use client";

import Image from "next/image";
import { useAuthenticationProviderQuery } from "@/modules/authentication/queries/use-authentication-provider-query";
import { KLoadingView } from "@/components/k-loading-view";
import { authenticationProvidersSchema } from "@/modules/authentication/schemas/authentication-providers-schema";
import { DuendeSignIn } from "@/modules/authentication/components/duende-sign-in";
import { CredentialSignIn } from "@/modules/authentication/components/credentials-sign-in";
import { useFlavor } from "@/modules/flavor/providers/flavor-provider";

export default function SignIn() {
    const flavor = useFlavor();

    const { data: providerName, isPending } = useAuthenticationProviderQuery();

    return (
        <div className="flex h-[100lvh] w-[100-lvw] items-center justify-center bg-foreground">
            <div className="flex items-center justify-center rounded bg-background px-4 py-12 sm:px-6 lg:px-8">
                <div className="flex w-full flex-col gap-3">
                    <div className="flex flex-col items-center justify-center gap-8">
                        {
                            <Image
                                width={100}
                                height={60}
                                alt={flavor.image.alt}
                                src={flavor.image.src}
                            />
                        }

                        {isPending && <KLoadingView />}

                        {providerName ===
                            authenticationProvidersSchema.enum.credentials && (
                            <CredentialSignIn provider={providerName} />
                        )}
                        {providerName ===
                            authenticationProvidersSchema.enum.duende && (
                            <DuendeSignIn provider={providerName} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
